webpackJsonp([212839066777427],{

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	  console.log(data);
	
	  return _react2.default.createElement(
	    "div",
	    { className: "ContentsContainer PostContainer" },
	    _react2.default.createElement(
	      "h2",
	      null,
	      "Moviendo el mundo",
	      _react2.default.createElement("br", null),
	      _react2.default.createElement(
	        "span",
	        null,
	        data.allMarkdownRemark.totalCount,
	        " Posts"
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "PostContent" },
	      data.allMarkdownRemark.edges.map(function (_ref2) {
	        var node = _ref2.node;
	        return _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: "PostLink", key: node.id, to: node.fields.slug },
	          _react2.default.createElement(
	            "div",
	            { className: "PostStyle", style: { marginTop: '30px' } },
	            _react2.default.createElement("img", { className: "PostImage", src: node.frontmatter.image, alt: "" }),
	            _react2.default.createElement(
	              "h3",
	              null,
	              node.frontmatter.title,
	              " ",
	              " ",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "span",
	                { color: "#BBB" },
	                " ",
	                node.frontmatter.by,
	                " / ",
	                node.frontmatter.date
	              )
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              node.excerpt,
	              " ",
	              node.frontmatter.description
	            )
	          )
	        );
	      })
	    )
	  );
	};
	
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-js-26abe5725af27f706f0a.js